import FormControlLabel, { type FormControlLabelProps } from '@mui/material/FormControlLabel';
import BaseSwitch, { type SwitchProps as BaseSwitchProps } from '@mui/material/Switch';
import { forwardRef } from 'react';

type SwitchProps = Omit<FormControlLabelProps, 'control' | 'label'> & {
  label?: FormControlLabelProps['label'];
  switchProps?: BaseSwitchProps;
};

const Switch = forwardRef(({ switchProps, label, ...props }: SwitchProps, ref) => {
  return (
    <FormControlLabel
      {...props}
      control={<BaseSwitch {...switchProps} />}
      ref={ref}
      label={label}
    />
  );
});

Switch.displayName = 'Switch';

export type { SwitchProps };
export { Switch };
